@if (isMulti()) {
  <elcia-multi-dropdown
    [control]="control()"
    [items]="priorities()"
    [label]="'todo.priority' | translate"
  />
} @else {
  <elcia-dropdown
    [control]="control()"
    [items]="priorities()"
    [label]="'todo.priority'| translate"
    [scrollHeight]="'140px'"
  />
}
